import DashboardIcon from '@mui/icons-material/DashboardOutlined';
import InventoryIcon from '@mui/icons-material/Inventory2Outlined';
import CategoryIcon from '@mui/icons-material/CategoryOutlined';
import LocalOfferIcon from '@mui/icons-material/LocalOfferOutlined';
import PriceCheckIcon from '@mui/icons-material/PriceCheckOutlined';
import RequestQuoteIcon from '@mui/icons-material/RequestQuoteOutlined';
import BoltIcon from '@mui/icons-material/BoltOutlined';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLongOutlined';
import ReceiptIcon from '@mui/icons-material/ReceiptOutlined';
import BuildIcon from '@mui/icons-material/BuildOutlined';
import HandymanIcon from '@mui/icons-material/HandymanOutlined';
import GroupIcon from '@mui/icons-material/GroupOutlined';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchangeOutlined';
import LocalShippingIcon from '@mui/icons-material/LocalShippingOutlined';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import CreditScoreIcon from '@mui/icons-material/CreditScoreOutlined';

import { ROLES } from '../../config';

// Configuracion de navegacion del panel admin.
// `roles` limita que item ve cada tipo de usuario (si se omite, lo ven todos los roles del dashboard).
const navConfig = [
  {
    subheader: 'general',
    items: [{ title: 'Dashboard', path: '/admin', icon: <DashboardIcon /> }],
  },
  {
    subheader: 'catálogo',
    roles: [ROLES.ADMINISTRADOR, ROLES.TECNICO],
    items: [
      { title: 'Productos', path: '/admin/productos', icon: <InventoryIcon /> },
      { title: 'Precios distribuidor', path: '/admin/precios-distribuidor', icon: <PriceCheckIcon /> },
      { title: 'Categorías', path: '/admin/categorias', icon: <CategoryIcon /> },
      { title: 'Marcas', path: '/admin/marcas', icon: <LocalOfferIcon /> },
    ],
  },
  {
    subheader: 'ventas',
    items: [
      {
        title: 'Venta express',
        path: '/admin/venta-express',
        icon: <BoltIcon />,
        roles: [ROLES.ADMINISTRADOR],
      },
      {
        title: 'Cotizador',
        path: '/admin/cotizador',
        icon: <CalculateOutlinedIcon />,
        roles: [ROLES.ADMINISTRADOR, ROLES.TECNICO],
      },
      {
        title: 'Cotizaciones',
        path: '/admin/cotizaciones',
        icon: <RequestQuoteIcon />,
        roles: [ROLES.ADMINISTRADOR, ROLES.TECNICO],
      },
      {
        title: 'Órdenes de venta',
        path: '/admin/pedidos',
        icon: <ReceiptLongIcon />,
        roles: [ROLES.ADMINISTRADOR],
      },
      {
        title: 'Boletas y facturas',
        path: '/admin/comprobantes',
        icon: <ReceiptIcon />,
        roles: [ROLES.ADMINISTRADOR],
      },
      {
        title: 'Delivery',
        path: '/admin/delivery',
        icon: <LocalShippingIcon />,
        roles: [ROLES.ADMINISTRADOR],
      },
      {
        title: 'Garantías',
        path: '/admin/garantias',
        icon: <VerifiedUserOutlinedIcon />,
        roles: [ROLES.ADMINISTRADOR],
      },
    ],
  },
  {
    subheader: 'servicio técnico',
    roles: [ROLES.ADMINISTRADOR, ROLES.TECNICO],
    items: [
      { title: 'Servicios', path: '/admin/servicios', icon: <HandymanIcon /> },
      { title: 'Órdenes de servicio', path: '/admin/ordenes-servicio', icon: <BuildIcon /> },
    ],
  },
  {
    subheader: 'finanzas',
    roles: [ROLES.ADMINISTRADOR],
    items: [
      { title: 'Créditos', path: '/admin/creditos', icon: <CreditScoreIcon /> },
      { title: 'Créditos por pagar', path: '/admin/creditos-por-pagar', icon: <AccountBalanceWalletIcon /> },
    ],
  },
  {
    subheader: 'administración',
    roles: [ROLES.ADMINISTRADOR],
    items: [
      { title: 'Usuarios y roles', path: '/admin/usuarios', icon: <GroupIcon /> },
      { title: 'Configuración', path: '/admin/configuracion', icon: <CurrencyExchangeIcon /> },
    ],
  },
];

export default navConfig;
